import primaSerata from "./scaletta_primaSerata.json";
import secondaSerata from "./scaletta_secondaSerata.json";
import terzaSerata from "./scaletta_terzaSerata.json";
import quartaSerata from "./scaletta_quartaSerata.json";
import finale from "./scaletta_finale.json";
import { songs } from "./songsData";

const monthMap = {
  gennaio: 0,
  febbraio: 1,
  marzo: 2,
  aprile: 3,
  maggio: 4,
  giugno: 5,
  luglio: 6,
  agosto: 7,
  settembre: 8,
  ottobre: 9,
  novembre: 10,
  dicembre: 11,
};

// Helper to parse "Martedì 24 febbraio 2026" -> Date
const parseDateString = (dateStr) => {
  const parts = dateStr.split(" "); // ["Martedì", "24", "febbraio", "2026"]
  // Handle cases where day name might not be present or format differs slightly
  // Assuming strict format "Dayname DD Month YYYY" for now based on json
  const dayIndex = parts.findIndex((p) => !isNaN(parseInt(p)));
  if (dayIndex === -1) return new Date(); // Fallback

  const day = parseInt(parts[dayIndex], 10);
  const monthStr = parts[dayIndex + 1];
  const month = monthMap[monthStr.toLowerCase()];
  const year = parseInt(parts[dayIndex + 2], 10);

  return new Date(year, month, day);
};

// Helper to add time to date
// Handles next day if hour < 12 (assuming events start in evening)
const parseEventTime = (baseDate, timeStr) => {
  const [hours, minutes] = timeStr.split(".").map(Number);
  const eventDate = new Date(baseDate);
  eventDate.setHours(hours, minutes, 0, 0);

  // If time is early morning (e.g. 01.00), add 1 day
  // Assuming show starts in the evening (after 12:00)
  if (hours < 12) {
    eventDate.setDate(eventDate.getDate() + 1);
  }
  return eventDate;
};

export const processSchedule = (json) => {
  if (!json) {
    console.error("processSchedule received null or undefined json");
    return null;
  }
  if (!json.data) {
    console.error("processSchedule received json without data property:", json);
    return { ...json, scaletta: [] };
  }
  const baseDate = parseDateString(json.data);
  return {
    ...json,
    scaletta: json.scaletta.map((item, index) => {
      const startTime = parseEventTime(baseDate, item.orario);
      const endTime = new Date(startTime.getTime() + item.durata_min * 60000);

      // Find artist in event string
      let artist = null;
      let matchedSong = null;

      // 0. Use explicit key if available
      if (item.key) {
        matchedSong = songs.find((s) => s.key === item.key);
      }

      // Fallback: Find the song that matches the artist in the event description
      if (!matchedSong) {
        matchedSong = songs.find((s) => {
          const eventUpper = item.evento.toUpperCase();
          const artistUpper = s.artist.toUpperCase();
          const titleUpper = s.title.toUpperCase();
          const coverTitleUpper = s.cover?.title?.toUpperCase();

          // 1. Direct artist match
          if (eventUpper.includes(artistUpper)) return true;

          // 2. Artist match with & instead of E (common in schedule)
          // Replace standalone "E" with "&"
          const artistWithAmp = artistUpper.replace(/\sE\s/g, " & ");
          if (eventUpper.includes(artistWithAmp)) return true;

          // 3. Artist match with E instead of & (if schedule has E and artist has &)
          const artistWithE = artistUpper.replace(/&/g, "E");
          if (eventUpper.includes(artistWithE)) return true;

          // 4. Title match (as fallback for different artist naming like "Fedez & Masini")
          if (eventUpper.includes(titleUpper)) return true;

          // 5. Cover Title match (for cover night)
          if (coverTitleUpper && eventUpper.includes(coverTitleUpper))
            return true;

          return false;
        });
      }

      if (matchedSong) {
        artist = matchedSong.artist;
      }

      return {
        ...item,
        id: index,
        startTime,
        endTime,
        artist,
        key: matchedSong ? matchedSong.key : item.key,
      };
    }),
  };
};

export const initialSchedules = {
  prima_serata: primaSerata,
  seconda_serata: secondaSerata,
  terza_serata: terzaSerata,
  quarta_serata: quartaSerata,
  finale: finale,
};

export const schedules = {
  prima_serata: processSchedule(primaSerata),
  seconda_serata: processSchedule(secondaSerata),
  terza_serata: processSchedule(terzaSerata),
  quarta_serata: processSchedule(quartaSerata),
  finale: processSchedule(finale),
};

export const nightLabels = {
  prima_serata: "Prima Serata",
  seconda_serata: "Seconda Serata",
  terza_serata: "Terza Serata",
  quarta_serata: "Quarta Serata",
  finale: "Finale",
};
